import {
    Button,
    Checkbox,
    Collapse,
    Dropdown,
    Input,
    Modal,
    Popover,
    Tabs,
} from "antd";
import React, { useEffect, useState } from "react";
import MoreIcon from "../../images/more-horizontal.png";
import EditIcon from "../../images/edit.svg";
import DeleteIcon from "../../images/delete.svg";
import CloseIcon from "../../images/close.svg";
import { toast } from "react-toastify";
import moment from "moment";
import { useLocation } from "react-router-dom";
import axios from "../../helpers/axios";
const { Panel } = Collapse;

const NewsLetter = () => {
    const accessToken = localStorage.getItem("agentModuleToken");
    const location = useLocation();
    //console.log("location", location.state);
    const pagePermission = location.state;
    const [NewsLetterList, setNewsLetterList] = useState([]);
    const [NewsLetterCount, setNewsLetterCount] = useState([]);
    const [pagination, setPagincation] = useState({
        pageSize: 25,
        page: 1,
    });
    const [confirmationModel, setConfirmationModel] = useState({
        open: false,
        id: "",
        type: "",
    });

    const ResetValues = () => {
        GetNewsLetterList();
        setConfirmationModel({
            open: false,
            id: "",
            type: "",
        });
    };

    const GetNewsLetterList = async () => {
        const resp = await axios.get(
            `/admin/newsletter/list/${pagination.pageSize}/${pagination.page}`
        );
        if (resp?.status < 400) {
            setNewsLetterCount(resp.data?.counts);
            setNewsLetterList(resp?.data.data);
        }
    };

    const UpdateRoleStatus = async (id, type) => {
        const resp = await axios.delete(
            type === "unsub"
                ? `admin/newsletter/unsubscribe/${id}`
                : `admin/newsletter/unsubscribe/${id}/${type}`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        if (resp?.data?.resp_code < 400) {
            toast.success(resp?.data?.message);
            ResetValues();
        }
    };

    const handleMenuClick = (type, id) => {
        if (type === "unsub") {
            UpdateRoleStatus(id, "");
        } else {
            UpdateRoleStatus(id, 1);
        }
    };

    useEffect(() => {
        GetNewsLetterList();
    }, []);

    return (
        <div className="min-h-screen bg-[#F5F5F5]">
            <div className="pt-[20px] px-[26px] bg-white">
                <div className="flex items-center gap-[15px] justify-between">
                    <h1 className="text-[20px] font-[700]">Newsletter</h1>
                </div>
            </div>
            <div className="px-[26px] bg-white border-b border-[#f0f0f0]"></div>
            <div className="px-[26px] pt-[20px]">
                <div className="bg-white p-[10px] rounded-[10px]">
                    <div className="userAcctableBox">
                        <table>
                            <thead>
                                <tr>
                                    <th>Created Date</th>
                                    <th>Updated Date</th>
                                    <th>Email</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                    {pagePermission?.update_permission == 1 && <th>Action</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {NewsLetterList?.length > 0 &&
                                    NewsLetterList?.map((item) => (
                                        <tr>
                                            <td>
                                                {moment(item?.created_at).format("DD MMMM YYYY")},{" "}
                                                {moment(item?.created_at).format("HH:mm")}
                                            </td>
                                            <td>
                                                {moment(item?.updated_at).format("DD MMMM YYYY")},{" "}
                                                {moment(item?.updated_at).format("HH:mm")}
                                            </td>
                                            <td>{item?.email}</td>
                                            <td>
                                                <div className="flex gap-[10px] items-center">
                                                    <span className="p-[6px] inline-block bg-[#E9EAEB] rounded-[4px] text-[#1B252F] text-[13px]">
                                                        {item?.deleted_at === null
                                                            ? "Subscribed"
                                                            : "Un Subscribed"}
                                                    </span>
                                                </div>
                                            </td>

                                            <td>
                                                <>
                                                    {item?.deleted_at === null ? (
                                                        <div
                                                            className="flex items-center gap-[10px] text-[#203B50] text-[13px] cursor-pointer"
                                                            onClick={() => {
                                                                setConfirmationModel({
                                                                    open: true,
                                                                    id: item?.id,
                                                                    type: "unsub",
                                                                });
                                                            }}
                                                        >
                                                            <img src={EditIcon} /> Un Subscribe
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className="flex items-center gap-[10px] text-[#F80707] text-[13px] cursor-pointer"
                                                            onClick={() => {
                                                                setConfirmationModel({
                                                                    open: true,
                                                                    id: item?.id,
                                                                    type: "delete",
                                                                });
                                                            }}
                                                        >
                                                            <img src={DeleteIcon} /> Delete
                                                        </div>
                                                    )}
                                                </>
                                            </td>
                                        </tr>
                                    ))}
                                {NewsLetterList?.length == 0 && (
                                    <tr>
                                        {" "}
                                        <td colspan="5" className="text-center">
                                            No records found
                                        </td>{" "}
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Modal
                title={
                    confirmationModel?.type === "unsub"
                        ? "Un Subscribe Application"
                        : "Delete Application"
                }
                centered
                open={confirmationModel?.open}
                onOk={() => {
                    handleMenuClick(confirmationModel?.type, confirmationModel?.id);
                }}
                onCancel={() =>
                    setConfirmationModel({
                        open: false,
                        id: "",
                        type: "",
                    })
                }
                wrapClassName="delApplModal"
                okText={
                    <>{confirmationModel?.type === "unsub" ? "Un Subscribe" : "Delete"}</>
                }
            >
                <p>
                    Are you sure want to{" "}
                    {confirmationModel?.type === "unsub" ? "un subscribe ?" : "delete ?"}
                </p>
            </Modal>
        </div>
    );
};

export default NewsLetter;
